import type { KioskInfo } from './apiKiosk';

/**
 * Tenant branding block shown at the top of both the kiosk service menu and
 * the issued-token screen, so a self-service token always carries the
 * centre's identity. The uploaded logo carries the branding when present —
 * like the display board — and the centre name is the no-logo fallback so
 * the header is never blank. Welcome copy sits below either way.
 */
export function KioskBrandHeader({ info }: { info: KioskInfo }): JSX.Element {
  return (
    <div className="flex flex-col items-center text-center">
      {info.logo_url ? (
        <img
          src={info.logo_url}
          alt={info.tenant_name}
          className="mb-4 h-20 w-auto max-w-[14rem] object-contain"
        />
      ) : (
        <h1 className="text-3xl font-bold">{info.tenant_name}</h1>
      )}
      {info.header_text ? (
        <p className="mt-1 max-w-xl whitespace-pre-wrap text-sm opacity-80">
          {info.header_text}
        </p>
      ) : null}
    </div>
  );
}
